import React from "react";
import { Link, Navigate } from "react-router-dom";
import { SidebarSkeleton } from "../../components";
import { AccountInterface, ApiHelper, ArrayHelper, PingInterface, ScreenInterface, UserHelper, ToastHelper } from "../../helpers";


interface Props {
  refreshKey: string
}


export const ScreensSidebar: React.FC<Props> = props => {

  const [screens, setScreens] = React.useState<ScreenInterface[]>(null);
  const [pings, setPings] = React.useState<PingInterface[]>([]);
  const [selectedScreen, setSelectedScreen] = React.useState<ScreenInterface>(null);
  const [redirect, setRedirect] = React.useState("");

  const init = () => {
    ApiHelper.get<ScreenInterface[]>("/screens")
      .then((data) => { setScreens(data || []); })
      .catch(err => {
        console.error("Failed to load screens:", err);
        ToastHelper.error("Failed to load screens");
      });
    ApiHelper.get<PingInterface[]>("/pings")
      .then((data) => {
        console.log("Pings", data)
        setPings(data || []);
      })
      .catch(err => console.error("Failed to load pings:", err));
  }

  const updateSelected = () => {
    let result: ScreenInterface = null;
    const parts = window.location.href.split("?")[0].split("/");
    const id = parseInt(parts[parts.length - 1]);
    screens?.forEach(s => { if (s.id === id) result = s; })
    setSelectedScreen(result);
  }


  React.useEffect(init, [props.refreshKey])
  React.useEffect(updateSelected, [screens, window.location.href]) //eslint-disable-line

  const confirmAddScreen = (e: React.MouseEvent) => {
    e.preventDefault();
    ApiHelper.get("/accounts/" + UserHelper.currentDepartment.accountId)
      .then((a: AccountInterface) => {
        if (a.perScreenCharge > 0) {
          const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
          const currency = formatter.format(a.perScreenCharge).replace(".00", "");
          if (window.confirm("There is a monthly fee of " + currency + "/screen after a trial period of 30 days.  Are you sure you wish to add this screen?'")) setRedirect("/screens/0");
        } else setRedirect("/screens/0");
      })
      .catch(err => console.error("Failed to load account details:", err));
  }

  const getScreens = () => {
    if (screens === null) return <SidebarSkeleton count={4} />
    else {
      const result: React.ReactElement[] = [];
      screens?.forEach(s => {
        let icon = <></>
        const ping: PingInterface = ArrayHelper.getOne(pings, "screenId", s.id);
        if (ping) {
          if (ping.currentSchedule === "") icon = <i className="fas fa-bed text-success" title="Sleeping"></i>
          else {
            let threshold = new Date(ping.pingTime);
            threshold.setMinutes(threshold.getMinutes() + 31);
            //threshold.setMinutes(threshold.getMinutes() + 480); //Not all players have updated to log impressions yet.  Leave a large 8 hour window.
            if (new Date() > threshold) icon = <i className="fas fa-wifi text-warning" title={ping.currentSchedule}></i>
            else icon = <i className="fas fa-play text-success" title={ping.currentSchedule}></i>
          }
        }
        let className = (s.id === selectedScreen?.id) ? "active" : "";
        result.push(<li key={"screen" + s.id} className="nav-item"><Link className={className} to={"/screens/" + s.id}>{icon} {s.name}</Link></li>);
      });
      return result;
    }
  }

  if (redirect !== "") {
    setTimeout(() => { setRedirect("") }, 100);
    return <Navigate to={redirect} replace />

  }
  else return (
    <>
      <div className="titlebar">
        <div className="float-right">
          <a href="about:blank" onClick={confirmAddScreen} className="btn btn-sm btn-success">
            <i className="fas fa-plus"></i> New
          </a>
        </div>
        <div className="title"><i className="fas fa-tv"></i> SCREENS</div>
      </div>
      <ul className={(screens?.length > 15) ? "nav flex-column condensed" : "nav flex-column"}>
        {getScreens()}
      </ul>
    </>
  );
};